import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../utils/seo';
export function NewsArticlePage() {
  return <div className="min-h-screen bg-white" data-id="element-506">
      <SEO title='Tourisme : le programme "Kafaa" vise à certifier 7.550 professionnels d&apos;ici 2026' description="Le programme &quot;Kafaa&quot; de validation des acquis de l'expérience (VAE) a pour objectif de certifier 7.550 professionnels d'ici 2026, avec un premier palier de 1.100 certifications pour l'année 2024" keywords="programme Kafaa, certification tourisme Maroc, VAE hôtellerie, Fatim-Zahra Ammor, formation professionnelle tourisme" ogImage="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop" ogType="article" data-id="element-507" />
      <Navbar data-id="element-508" />
      <article className="py-20 px-4 md:px-8" data-id="element-509">
        <div className="container mx-auto max-w-6xl" data-id="element-510">
          {/* Header Section - 2 columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-511">
            <div data-id="element-512">
              <h1 className="text-[36px] md:text-[48px] font-bold text-arih-dark leading-[1.2]" data-id="element-513">
                Tourisme : le programme "Kafaa" vise à certifier 7.550
                professionnels d'ici 2026 (Mme Ammor)
              </h1>
            </div>
            <div data-id="element-514">
              <p className="text-[18px] text-arih-gray leading-[32px] italic" data-id="element-515">
                Rabat - Le programme "Kafaa" de validation des acquis de
                l'expérience (VAE) a pour objectif de certifier 7.550
                professionnels d'ici 2026, avec un premier palier de 1.100
                certifications pour l'année 2024, a indiqué la ministre du
                Tourisme, de l'Artisanat et de l'Économie sociale et solidaire,
                Fatim-Zahra Ammor.
              </p>
            </div>
          </div>

          {/* Featured Image */}
          <div className="mb-16" data-id="element-516">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop" alt="Fatim-Zahra Ammor" className="w-full max-w-4xl mx-auto h-[500px] object-cover rounded-xl" data-id="element-517" />
          </div>

          {/* Article Content */}
          <div className="max-w-3xl mx-auto space-y-8 text-[18px] text-arih-dark leading-[32px]" data-id="element-518">
            <p data-id="element-519">
              Cette première vague couvre un large éventail de métiers
              essentiels, comme l'accueil, la restauration ou l'hébergement, a
              expliqué Mme Ammor à la MAP, ajoutant que cela va du
              réceptionniste au chef de cuisine, en passant par les gouvernantes
              d'hôtel et les maîtres d'hôtel.
            </p>

            <p data-id="element-520">
              Et de soutenir : "L'idée est de créer un cercle vertueux. En
              valorisant les compétences de nos professionnels, nous renforçons
              leur motivation à offrir le meilleur d'eux-mêmes, créant ainsi une
              expérience touristique inoubliable".
            </p>

            <p data-id="element-521">
              Considéré comme une initiative novatrice de la feuille de route du
              tourisme, fruit d'une collaboration entre le ministère et la
              Confédération Nationale du Tourisme (CNT), le programme "Kafaa"
              permettra de valoriser et certifier les compétences des
              professionnels du tourisme qui n'ont pas suivi un parcours de
              formation traditionnel, mais qui ont acquis une expérience et des
              compétences sur le terrain au fil des années, a rappelé Mme Ammor.
            </p>

            <p data-id="element-522">
              Pour elle, ce programme offre à ces professionnels une opportunité
              unique de faire reconnaître officiellement ces compétences et
              trace une nouvelle voie d'accès à la certification, ouverte à tous
              les employés ayant au moins trois ans d'expérience avérée dans le
              tourisme, la restauration ou l'hôtellerie.
            </p>

            <p data-id="element-523">
              Parallèlement, Mme Ammor a révélé que le Programme National de
              Formation, mené par le ministère en collaboration avec l'Office de
              la formation professionnelle et de la promotion du travail (OFPPT)
              et la CNT, avance à grands pas.
            </p>

            <p data-id="element-524">
              "Pour le volet Cap Excellence, nous avons sélectionné 12
              Établissements de Formation Professionnelle (EFP) à travers le
              Maroc qui vont bénéficier d'une véritable transformation. Nous
              allons moderniser leur offre de formation, améliorer leur
              gouvernance et mettre en place un système de management de la
              qualité", a-t-elle fait savoir.
            </p>

            <p data-id="element-525">
              Il s'agit d'un projet ambitieux qui sera déployé en deux phases,
              avec la mise à niveau de 6 établissements en 2024-2025, suivis de
              6 autres en 2026, a expliqué la ministre.
            </p>

            <p data-id="element-526">
              "Nous sommes profondément convaincus que l'investissement dans nos
              ressources humaines est l'une des clés pour hisser notre industrie
              touristique au plus haut niveau international. En valorisant les
              compétences de nos professionnels et en offrant des formations de
              qualité, nous préparons le secteur à relever les défis futurs et à
              offrir une expérience touristique exceptionnelle", a conclu Mme
              Ammor.
            </p>
          </div>

          {/* Navigation */}
          <div className="max-w-3xl mx-auto mt-16 pt-8 border-t border-gray-200 flex justify-between" data-id="element-527">
            <a href="/news" className="text-[16px] text-arih-blue font-semibold hover:underline" data-id="element-528">
              ← Retour aux actualités
            </a>
            <a href="/news" className="text-[16px] text-arih-blue font-semibold hover:underline" data-id="element-529">
              Article suivant →
            </a>
          </div>
        </div>
      </article>
      <Footer data-id="element-530" />
    </div>;
}